import { gql } from "../__generated__/gql";

gql(`
    fragment PayslipFields on Payslip {
        id
        yearMonth
        year
        month
        paidDate
        netAmount
        grossAmount    
        asset {
            ...AssetFields
        }
        missionInfo {
            ...MissionInfoFields
        }
    }
`);

gql(`
    fragment SalaryFields on Salary {
        id
        yearMonth
        year
        netAmount
        month
        paidAt
        grossAmount
        salaryAsset {
            ...AssetFields
        }
        missionsInfo {
            ...MissionInfoFields
        }
        payslips {
            ...PayslipFields
        }
    }
`);

export const FIND_MY_SALARIES = gql(`
    query FindMySalaries($offset: Int, $limit: Int) {
        findMySalaries(offset: $offset, limit: $limit) {
            count
            elements {
                ...SalaryFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

export const GET_LPP_PLANS = gql(`
    query GetLppPlans($cctContractId: String!) {
        getLppPlans(cctContractId: $cctContractId) {
            ...LPPPlanFields
        }
    }
`);

export const GET_SALARY_DETAILS = gql(`
    query GetSalaryDetails(
        $cctEditionId: String!
        $cctDetailsValues: [CCTDetailsFieldValueInput!]
        $workerProfileId: String!
        $requestedSalaryType: SalaryType
        $requestedSalary: Int
        $vacationDays: Int
        $has13thSalary: Boolean
        $earningType: EarningType
        $workingTimeClassicSpec: WorkingTimeClassicInput!
        $hoursPerWeekFullTime: Decimal
        $ijmGroupId: String
        $workerProfileInfo: WorkerInfoInput
        $missionStateCode: String
        $legalEmployerId: String
        $activityTypeId: String
        $startDate: Date
        $endDate: Date
        $lppPlanId: String
        $disableAvsSmallSalaryExemption: Boolean
        $forceLpp: Boolean
        $payVacationIndemnityWithSalary: Boolean
        $pay13thSalaryWithSalary: Boolean
    ) {
        getSalaryDetails(
            cctEditionId: $cctEditionId
            cctDetailsValues: $cctDetailsValues
            workerProfileId: $workerProfileId
            requestedSalaryType: $requestedSalaryType
            requestedSalary: $requestedSalary
            vacationDays: $vacationDays
            has13thSalary: $has13thSalary
            earningType: $earningType
            workingTimeClassicSpec: $workingTimeClassicSpec
            hoursPerWeekFullTime: $hoursPerWeekFullTime
            ijmGroupId: $ijmGroupId
            workerProfileInfo: $workerProfileInfo
            missionStateCode: $missionStateCode
            legalEmployerId: $legalEmployerId
            activityTypeId: $activityTypeId
            startDate: $startDate
            endDate: $endDate
            lppPlanId: $lppPlanId
            disableAvsSmallSalaryExemption: $disableAvsSmallSalaryExemption
            forceLpp: $forceLpp
            payVacationIndemnityWithSalary: $payVacationIndemnityWithSalary
            pay13thSalaryWithSalary: $pay13thSalaryWithSalary
        ) {
            requestedSalary
            requestedSalaryType
            baseSalary
            netSalary
            grossSalary
            invoiceSalary
            totalCompensation
            vacationCompensation
            publicHolidaysCompensation
            thirteenMonthCompensation
            totalWorkerDeductions
            lseMargin
            workerDeductions {
                title
                quantity
                rate
                amount
                intercomArticleId
                i18nValue
                appliedMonthly
            }
            totalClientDeductions
            clientDeductions {
                title
                quantity
                rate
                amount
                intercomArticleId
                i18nValue
                appliedMonthly
            }
            vacationDays
            has13thSalary
            pay13thSalaryWithSalary
            minBaseSalary
            minGrossSalary
            minNetSalary
            minInvoiceSalary
            mandatory13thMonth
            minVacationDays
            clientMissionFeesRate
            contributionBase
            deferredIndemnity
        }
    }
`);

export const GET_SALARY_FORECAST = gql(`
    query GetSalaryForecast(
        $nbMonths: Int
        $monthYear: Date!
        $netSalary: Int!
        $grossSalary: Int!
        $invoiceSalary: Int!
        $earningType: EarningType!
        $contractStartDate: Date!
        $workingTimeClassicSpec: WorkingTimeClassicInput!
        $contractEndDate: Date
        $hoursPerWeekFullTime: Float!
        $workingAddressStateCode: String
        $fees: [MissionFeeInput!]!
        $deductions: [MissionDeductionInput!]!
        $deferredIndemnity: Int
        $contractId: ID
        $forWorker: Boolean
        $has13thSalary: Boolean
        $pay13thSalaryWithSalary: Boolean
        $thirteenMonthCompensation: Int
        $workerDeductions: [SalaryForecastDeductionInput!]
    ) {
        getSalaryForecast(
            nbMonths: $nbMonths
            monthYear: $monthYear
            netSalary: $netSalary
            grossSalary: $grossSalary
            invoiceSalary: $invoiceSalary
            earningType: $earningType
            contractStartDate: $contractStartDate
            workingTimeClassicSpec: $workingTimeClassicSpec
            contractEndDate: $contractEndDate
            hoursPerWeekFullTime: $hoursPerWeekFullTime
            workingAddressStateCode: $workingAddressStateCode
            fees: $fees
            deductions: $deductions
            deferredIndemnity: $deferredIndemnity
            contractId: $contractId
            forWorker: $forWorker
            has13thSalary: $has13thSalary
            pay13thSalaryWithSalary: $pay13thSalaryWithSalary
            thirteenMonthCompensation: $thirteenMonthCompensation
            workerDeductions: $workerDeductions
        ) {
            monthYear
            monthStartDate
            monthEndDate
            grossSalary
            netSalary
            invoiceSalary
            includedFeesAmount
            includedDeductionsAmount
            includedClientDeductionsAmount
            includedWorkerDeductionsAmount
        }
    }
`);

export const GET_SALARY = gql(`
    query GetSalary($salaryId: ID!) {
        getSalary(salaryId: $salaryId) {
            ...SalaryFields
        }
    }
`);

export const GET_PAYSLIP = gql(`
    query GetPayslip($payslipId: ID!) {
        getPayslip(payslipId: $payslipId) {
            ...PayslipFields
        }
    }
`);
